var _desc, _defs, _rect, _rect2, _g, _line, _g2, _g3, _g4, _g5, _path, _circle, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppliedIntelligenceFlowDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 560",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "From friction to intelligent flow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "People, data and systems connect through an applied intelligence layer to create better business flow.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "flow",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#087CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#20C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2775"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "core"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#087CFF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#087CFF",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 34,
    height: 34,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 0H0V34",
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.065,
    strokeWidth: 0.8
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 638,
    height: 558,
    rx: 28,
    fill: "#071225",
    stroke: "#4D607E",
    strokeOpacity: 0.68,
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 604,
    height: 524,
    rx: 20,
    fill: "url(#grid)",
    stroke: "#8CA0BD",
    strokeOpacity: 0.16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Inter, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("text", {
    x: 44,
    y: 62,
    fill: "#FFFFFF",
    fontSize: 14,
    fontWeight: 760,
    letterSpacing: 3
  }, "FROM FRICTION TO FLOW"), /*#__PURE__*/React.createElement("text", {
    x: 596,
    y: 62,
    fill: "#7085A3",
    fontSize: 11,
    fontWeight: 700,
    textAnchor: "end"
  }, "CUSTOM-BUILT"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 82,
    x2: 596,
    y2: 82,
    stroke: "#40516A",
    strokeOpacity: 0.65
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Inter, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(55 150)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 54,
    rx: 12,
    fill: "#0B1A31",
    stroke: "#49607E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 15,
    fill: "#102744",
    stroke: "#087CFF",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 22,
    r: 4,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 35c1-5 4-7 7-7s6 2 7 7",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 53,
    y: 33,
    fill: "#FFFFFF",
    fontSize: 14,
    fontWeight: 680
  }, "People")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55 242)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 54,
    rx: 12,
    fill: "#0B1A31",
    stroke: "#49607E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 15,
    fill: "#102744",
    stroke: "#087CFF",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 21h14M20 27h14M20 33h14",
    stroke: "#087CFF",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 53,
    y: 33,
    fill: "#FFFFFF",
    fontSize: 14,
    fontWeight: 680
  }, "Data")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55 334)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 54,
    rx: 12,
    fill: "#0B1A31",
    stroke: "#49607E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 15,
    fill: "#102744",
    stroke: "#087CFF",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 21-6 6 6 6M32 21l6 6-6 6M29 18l-4 18",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 53,
    y: 33,
    fill: "#FFFFFF",
    fontSize: 14,
    fontWeight: 680
  }, "Systems")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.7,
    strokeOpacity: 0.82
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191 177h54c28 0 37 44 64 73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191 269h100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191 361h54c28 0 37-44 64-73"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#087CFF",
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 177,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 361,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 269,
    r: 3
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(385 269)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 118,
    fill: "url(#core)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 87,
    fill: "#061127",
    stroke: "#1E4067",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 77,
    fill: "none",
    stroke: "#173A61",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("circle", {
    r: 77,
    fill: "none",
    stroke: "url(#flow)",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeDasharray: "405 78",
    transform: "rotate(-88)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 100,
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.33,
    strokeDasharray: "2 7"
  }), /*#__PURE__*/React.createElement("text", {
    y: -5,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 760,
    textAnchor: "middle",
    letterSpacing: 1.2
  }, "APPLIED"), /*#__PURE__*/React.createElement("text", {
    y: 19,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 760,
    textAnchor: "middle",
    letterSpacing: 1.2
  }, "INTELLIGENCE"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M472 269h79",
    fill: "none",
    stroke: "url(#flow)",
    strokeWidth: 2.3,
    filter: "url(#glow)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 551,
    cy: 269,
    r: 4,
    fill: "#FF2775",
    filter: "url(#glow)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(508 211)",
    fontFamily: "Inter, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 116,
    rx: 18,
    fill: "#0D1D35",
    stroke: "#6A3B65",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 37,
    r: 19,
    fill: "#1A2F4B",
    stroke: "#FF2775",
    strokeOpacity: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 38h22m-6-6 6 6-6 6",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 78,
    fill: "#FFFFFF",
    fontSize: 13,
    fontWeight: 760,
    textAnchor: "middle"
  }, "BETTER"), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 97,
    fill: "#FFFFFF",
    fontSize: 13,
    fontWeight: 760,
    textAnchor: "middle"
  }, "FLOW"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(44 455)",
    fontFamily: "Inter, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 552,
    height: 68,
    rx: 14,
    fill: "#0A172B",
    stroke: "#3B506D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 19,
    fill: "#102744",
    stroke: "#087CFF",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 34 6 6 12-14",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 29,
    fill: "#087CFF",
    fontSize: 10.5,
    fontWeight: 760,
    letterSpacing: 1.7
  }, "CUSTOM-BUILT AROUND YOUR OPERATIONS"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 49,
    fill: "#FFFFFF",
    fontSize: 13.2
  }, "Less friction \xB7 Faster decisions \xB7 Measurable productivity"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliedIntelligenceFlowDesktop);
export default __webpack_public_path__ + "static/media/applied-intelligence-flow-desktop.d50ce8e2bdd473089506e5d47a714bdc.svg";
export { ForwardRef as ReactComponent };